import CreateWidgetHostConfigRequestModelBase from '../_generated/modelBases/create-widget-host-config-request-model-base';

export default class CreateWidgetHostConfigRequestModel extends CreateWidgetHostConfigRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
